import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';

import { SmartReviewStepFooterProps } from '../../SmartReviewOnboardingModal.types';
import { usePresentationStepContext } from './PresentationTemplateSelectionStep.context';

export function PresentationFooter({ onBack }: SmartReviewStepFooterProps) {
  const { selectedTemplateIds, completeOnboarding, isCompleting } =
    usePresentationStepContext();

  return (
    <Stack direction="row" justifyContent="flex-end" gap={1} width="100%">
      <Button
        variant="secondary"
        size="sm"
        onClick={onBack}
        disabled={isCompleting}
      >
        Previous
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={() => completeOnboarding(selectedTemplateIds)}
        loading={isCompleting}
        disabled={selectedTemplateIds.length === 0}
      >
        Done
      </Button>
    </Stack>
  );
}
